module.exports = __webpack_public_path__ + "static/media/setting-light.b90cd84e.svg";